import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page96() {
  useEffect(() => {
    document.title = "Маяк — Страница 95"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page94" />
        <ForwardLink href="/page96" />
      </div>

      <p style={{ textAlign: "right" }}>95.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ЗА КАДРОМ)<br/>
        СВЕТ ПРИНАДЛЕЖИТ МНЕ!
      </p>
      <p>
        СТАРИК, покрытый илом, едва живой, взмахивает ТОПОРОМ, раня<br/>
        в плечо МОЛОДОГО. Кровь хлещет из раны.
      </p>
      <p>
        МОЛОДОЙ берет ЖЕЛЕЗНЫЙ ЧАЙНИК и размахивается, ударяя СТАРИКА<br/>
        по ЛИЦУ.
      </p>
      <p>СТАРИК тяжело падает на землю, стонет...</p>
      <p>МОЛОДОЙ ПОДНИМАЕТ ТОПОР...</p>
      <p>ОН ПОДНИМАЕТ ЕГО ВЫСОКО...</p>
      <p>СТАРИК пытается защититься руками...</p>
      <p>
        МОЛОДОЙ ВОНЗАЕТ ТОПОР В ГОЛОВУ СТАРИКА С ЛЕДЕНЯЩИМ КРОВЬ<br/>
        ХРУСТОМ! (Голова СТАРИКА ЗА КАДРОМ, но ясно, что именно это<br/>
        и произошло).
      </p>
      <p>
        КРОВЬ БРЫЗГАЕТ ПО ВСЕЙ КОМНАТЕ. Его старые конечности на мгновение<br/>
        дергаются и падают обратно на пол.
      </p>
      <p>Пауза.</p>
      <p>МОЛОДОЙ хромает, весь в крови, возвращается к столу.</p>
      <p>Он скручивает сигарету, его руки трясутся.</p>
      <p>Курит.</p>
      <p>Он наливает немного скипидара в ближайшую чашку.</p>
      <p>Смотрит на СТАРИКА, рукоятка топора торчит из его головы.</p>
      <p>МОЛОДОЙ поднимает чашку. Рука трясется. Произносит тост.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Пусть смерть бледная с тройным ужасом<br/>
        сделает океанские пещеры нашей могилой,<br/>
        Бог, который слышит раскаты волн,<br/>
        соблаговоли спасти просящую душу.
      </p>
      <p>Он выпивает.</p>
      <p>Задержка.</p>
      <p>
        МУЗЫКАЛЬНАЯ ВСТАВКА: Жуткая “легкая” музыка. Продолжается до конца<br/>
        фильма.
      </p>
      <p style={{ textAlign: "right" }}>95.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page94" />
        <ForwardLink href="/page96" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710719074/the-lighthouse-script/ul3dggo6idjhiildkzyo.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page96;
